import db from "../../../db/database";
import { formatAxiosError } from "../../../utils/common";
import { getCurrentDateTimeISO } from "../../../utils/dateUtils";
import { postInvoice } from "../../../utils/businessCentralUtils";
import { getSystemIdAndInvoice } from "../../../utils/sicfeUtils";
import { getFinalDocumentNo } from "../../../services/invoiceSyncService";

export const handleContabilizarFactura = async (invoice, clients, setLoading, country) => {
    setLoading(true)

    try {
        //Para contabilizar se necesita el systemId
        const client = clients.find(
            (c) =>
                c.No === invoice.Sell_to_Customer_No_ ||
                c.id === invoice.clientLocalId
        );
        invoice.Sell_to_Customer_No_ = client.No;
        const { systemId } = await getSystemIdAndInvoice(invoice);
        if (!systemId) {
            window.messageApi.error("La factura esta en proceso.");
            return;
        }

        const isCreditMemo = invoice.Document_Type === 'Credit Memo';
        const posted = await postInvoice(systemId, isCreditMemo);

        if (posted) {
            await db.invoices.update(invoice.id, {
                lastSynced: getCurrentDateTimeISO(),
                posted: 1, //marco contabilizacion exitosa
                syncStage: "posted",
                pendingSync: 0,
            });
            const postedInvoice = await db.invoices.get(invoice.id);
            await getFinalDocumentNo(postedInvoice, country);

            window.messageApi.success("Factura contabilizada correctamente");
            return;
        }
    }
    catch (error) {
        window.messageApi.error(formatAxiosError(error, "Falló servicio de contabilización de factura."));
        return;
    }
    finally { setLoading(false) }
}
